import { CreateRelationsCommand, DeleteRelationsCommand, useCreateRelationMutation, useDeleteRelationMutation, useGetRelationsOutByIdQuery } from "../../../services/objects"
import { ListPanelWrapper } from "../ListPaneWrapper"
import { FormattedMessage, useIntl } from "react-intl"
import { ObjectNavigatorModal } from "../../../features/ObjectSelector/Modal"
import { useState } from "react"
import { Button } from "baseui/button"
import { IAutomationObject } from "../../types"
import { useReportMutationState } from '../../../hooks/useReportMutationState'
import { VscAdd, VscTrash } from "react-icons/vsc"
import { EmptyState } from "../../../components/EmptyState"
import { useStyletron } from "baseui"
import { RELATION_TYPE } from "../../../services/objects"
import { useHasRole, AccessRoles } from "../../../hooks/useHasRole"
import { LabelSmall } from "baseui/typography"

export const LogicRefrerence = (props: { automationApp: IAutomationObject, type: keyof typeof RELATION_TYPE, enableAdd: boolean, text: string }) => {
    const [css,] = useStyletron();
    const intl = useIntl();
    const { data, isLoading, isSuccess, error, refetch } = useGetRelationsOutByIdQuery({ objectId: props.automationApp.id, resourceGroupId: props.automationApp.resourceGroupId, type: props.type })
    const hasAdminAccess = useHasRole(AccessRoles.Mapping.Write);
    const [deleteRelation, deleteRelationResult] = useDeleteRelationMutation();
    useReportMutationState(deleteRelationResult, () => { setTimeout(() => { refetch(); }, 2000) });

    const handleDeleteRelation = (selected: IAutomationObject) => {
  
        const cmd2: DeleteRelationsCommand = {
            fromObjectId: props.automationApp.id,
            resourceGroupId: props.automationApp.resourceGroupId,
            toObjectId: selected.id,
            type: props.type
        }
        deleteRelation(cmd2)
    };

    const handleNewLinkAdded = () => {
        setTimeout(() => { refetch(); }, 2000);
    }

    return (
        <>
            <div className={css({ position: 'relative' })}>
                {data && data.length === 0 && hasAdminAccess &&
                    <>
                    <LabelSmall>{props.text}</LabelSmall>
                    <EmptyState header={intl.formatMessage({ id: 'logicreference.noreference', defaultMessage: "No reference" })} message={intl.formatMessage({ id: 'logicreference.nonoreferencedescr', defaultMessage: "There is no reference" })}></EmptyState>
                    </>
                }
                {data && data.map((target) =>
                    <>
                     <LabelSmall>{props.text}</LabelSmall>
                    <ListPanelWrapper {...target} endEnhancer={<Button onClick={() => handleDeleteRelation(target)} size="compact" kind="tertiary" shape="circle"><VscTrash></VscTrash></Button>}></ListPanelWrapper></>)
                }
                {props.enableAdd && data && data.length === 0 && hasAdminAccess &&
                    <div className={css({ position: 'absolute', bottom: "-20px", right: "-20px" })}>
                        <AddLink automationApp={props.automationApp} type={props.type} onAdded={handleNewLinkAdded}></AddLink>
                    </div>
                }
            </div>
        </>
    )
}

const AddLink = (props: { automationApp: IAutomationObject, type: keyof typeof RELATION_TYPE, onAdded: any }) => {
    const [isOpen, setIsOpen] = useState(false);

    const [addRelation, addRelationResult] = useCreateRelationMutation();
    useReportMutationState(addRelationResult, () => { props.onAdded(); });

    const handleSelect = (selected: IAutomationObject) => {

        const cmd2: CreateRelationsCommand = {
            fromObjectId: props.automationApp.id,
            resourceGroupId: props.automationApp.resourceGroupId,
            toObjectId: selected.id,
            type: props.type
        }
        addRelation(cmd2)

    };

    const handleFilter = (app: IAutomationObject) => {
        return app.resourceGroupId === props.automationApp.resourceGroupId
    }

    return (
        <>

            <Button shape='circle' kind='secondary' onClick={() => setIsOpen(true)}><VscAdd /></Button>
            <ObjectNavigatorModal isOpen={isOpen} setIsOpen={(v) => setIsOpen(v)} currentSelectedParent={props.automationApp}
                onSelected={handleSelect}
                filter={handleFilter}
                title={<FormattedMessage id='logicreference.selectreference' defaultMessage={'Select Reference'}></FormattedMessage>}
            ></ObjectNavigatorModal>
        </>)
}